import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';

@Component({
  selector: 'app-product-list-voucher-component',
  templateUrl: './product-list-voucher-component.component.html',
  styleUrls: ['./product-list-voucher-component.component.scss'],
})
export class ProductListVoucherComponentComponent implements OnInit {

  productBarcode: any = "";
  @Input() mstProductList: any[];
  @Input() selectedProduct: any;
  @Input() action: any;
  @Input() token: any;
  @Input() counterId: any;
  @Input() viewOnly:any;
  productList: any[] = [];
  products: any[]=[];
  keyword:any;
  checkedAllProduct : boolean = false;
  @ViewChild('productComponent', { static: false }) productComponent: IonicSelectableComponent;
  
  
  constructor(
    public modalController: ModalController,
    private toastCtrl: ToastController,
    private alertController: AlertController,
  ) { }

  ngOnInit() {
    this.setProductList();
  }

  setProductList() {
    this.productList = [];
    let listProduct: any[] = this.selectedProduct.trim().split(',');
    console.log(this.mstProductList);
    console.log(listProduct);
    if(listProduct.length > 0) {
      for(let i = 0; i < listProduct.length; i++) {
        let reguler: any =this.mstProductList.find(x=> x.id===listProduct[i]);
        if(reguler){
          this.productList.push({
            id: reguler.id,
            barcode: reguler.barcode,
            name: reguler.product_name
          });
        }
      }
    }
    console.log(this.productList)
  }
  async getProduct(productBarcode: any) {
    this.keyword=productBarcode;
    this.products = [];
    if(this.keyword.length >= 3) {
      this.products = [];
      let reguler: any =this.mstProductList.filter(x=> x.id.toUpperCase().includes(this.keyword.toUpperCase()) || x.product_name.toUpperCase().includes(this.keyword.toUpperCase()) || (x.barcode !==null && x.barcode.includes(this.keyword.toUpperCase())));
      if(reguler.length >0){
        for(let g=0;g<reguler.length;g++){
          this.products.push({
            id: reguler[g].id,
            barcode: reguler[g].barcode,
            product_name: reguler[g].product_name
          });
        }
      }
    }
    else{
      this.toastCtrl.create({ duration: 2000, message: 'Minimum 3 karakter' }).then(t => t.present());
    }
  }

  async dismissModal() {
    await this.modalController.dismiss(this.productList.length > 0 ? this.productList : '');
  }

  scrollDownEnd() {
    setTimeout(()=>{   
        var elem = document.getElementById('item');
        elem.scrollTop = elem.scrollHeight;
    }, 50);
  }

  async showAlertBarcodeNotValid(message: any) {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: message,
      backdropDismiss: true,
      buttons: [
        {
          text: 'OK',
          handler: () => {}
        }
      ]
    });

    await alert.present();
  }

  deleteDetail(index: any) {
    this.productList.splice(index, 1);
  }

  chooseProduct(productId: any) {
    if(productId !== '' && productId !== undefined) {
      let checkItemPcode: any[] = this.productList.find(x => x.id === productId.id);
      if (checkItemPcode === undefined) {
        this.productList.push({
          id: productId.id,
          barcode: productId.barcode,
          name: productId.product_name
        });
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Product sudah ada di list!' }).then(t => t.present());
      }
    }
    (<HTMLInputElement>document.getElementById("inputBarcode")).focus();
  }
  
  toggleCounterItems() {
    this.productComponent.toggleItems(
      this.productComponent.itemsToConfirm.length ? false : true
    );
  }

  confirmCounter() {
    this.productComponent.confirm();
    this.productComponent.close();
    
    let selectedProductList = [];
    selectedProductList = this.productComponent.value;
    for(let i=0;i<selectedProductList.length;i++){
      let idProduct = selectedProductList[i].id;
      let findProduct = this.products.find(x=>x.id==idProduct)
      if(findProduct){
        this.productList.push({
          id: findProduct.id,
          barcode: findProduct.barcode,
          name: findProduct.product_name
        });
      }
    }
  }
  
  selectCheckboxCounter(product_id:any,checked:any){
    console.log(product_id);
    console.log(this.productList);
    console.log(this.products);
    if(this.products.length > 0) {
      let Checbox = (this.products.find(x => x.id === product_id));
     let indexChecbox = (this.products.findIndex(x => x.id === product_id));
      if(checked=='check'){
        this.products[indexChecbox].isChecked=true;
        let cari =this.productList.find(x=>x.id==product_id);
        if(cari==undefined){
          this.chooseProduct(Checbox);
          if(this.productList.length==this.products.length){
            this.checkedAllProduct=true;
          }
          else{
            this.checkedAllProduct==false;
          }
        }
      }
      else{
        this.products[indexChecbox].isChecked=false;
        let cari =this.productList.find(x=>x.id==product_id);
        if(cari!==undefined){
          let index = this.productList.indexOf(cari);
          this.productList.splice(index, 1);
          this.checkedAllProduct=false;
        }
      }
    }
    
  }
  uncheckAllProduct() {
    if(this.products.length > 0) {
      for(let i = 0; i < this.products.length; i++) {
        if(this.checkedAllProduct === true) {
          this.products[i].isChecked = false; 
          let cari =this.productList.find(x=>x.id==this.products[i].id);
          if(cari!==undefined){
            let index = this.productList.indexOf(cari);
            this.productList.splice(index, 1);
          }      
        }else{
          this.products[i].isChecked = true;
          let cari =this.productList.find(x=>x.id==this.products[i].id);
          if(cari==undefined){
            this.chooseProduct(this.products[i]);
          }
        }
      }
      if(this.checkedAllProduct === true) {
        this.checkedAllProduct = false;
      }
      else{          
        this.checkedAllProduct = true;
      }
    }
  }

}
